import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { AuthService, OrganizationAccountGroupService } from "@front/m19-services";
import { IButtonDirective, IIconComponent, ITooltipDirective, SpinnerComponent } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { LogoComponent } from "@m19-board/shared/logo/logo.component";
import { take } from "rxjs";

@Component({
  selector: "app-suspension",
  standalone: true,
  imports: [TranslocoDirective, IButtonDirective, LogoComponent, ITooltipDirective, SpinnerComponent, IIconComponent],
  template: `<ng-container *transloco="let t">
    <div class="flex h-screen flex-1 flex-col overflow-hidden">
      <header class="sticky top-0 flex flex-col">
        <div class="flex w-full min-w-0 flex-1 items-center justify-between px-4">
          <div class="flex h-14 items-center justify-center p-2">
            <app-logo class="block h-full"></app-logo>
          </div>
          <button
            iButton
            [iTooltip]="t('dashboard360-layout.logout')"
            variant="ghost"
            size="icon-sm"
            testId="logout-button"
            (click)="logout()"
          >
            <IIcon name="logout" />
          </button>
        </div>
      </header>
      <div class="flex flex-1 justify-center pb-10">
        <div class="flex min-h-screen items-center justify-center">
          <div class="max-w-md rounded-lg bg-white p-8 text-center shadow-lg">
            <div class="mb-4 flex justify-center">
              <IIcon name="alertTriangle" class="text-destructive text-4xl" />
            </div>
            <h1 class="mb-2 text-2xl font-bold text-gray-900">{{ t("suspension.access_suspended") }}</h1>
            @let org = suspendedOrganization();
            @if (org) {
              @if (org.organization.parentOrganizationId) {
                <p class="mb-6 text-gray-600">
                  {{ t("suspension.child_organization_message") }}
                </p>
              } @else {
                <p class="mb-6 text-gray-600">{{ t("suspension.access_suspension_description_1") }}</p>
                <p class="mb-6 text-gray-600">
                  {{ t("suspension.access_suspension_description_2") }}
                </p>
              }
            } @else {
              <ISpinner class="mx-auto mb-6"></ISpinner>
            }
          </div>
        </div>
      </div>
    </div>
  </ng-container>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuspensionComponent {
  private readonly authService = inject(AuthService);
  private readonly organizationAccountGroupService = inject(OrganizationAccountGroupService);

  readonly suspendedOrganization = toSignal(
    this.organizationAccountGroupService.blockingSuspendedOrganization$.pipe(take(1)),
  );
  logout() {
    this.authService.logout(true);
  }
}
